import './app.css'
import App from './App.svelte'

// Parse URL parameters to check for model ID
function getUrlParameter(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

// Find model by ID in the models array
function findModelById(id) {
  if (!id || !window.models) return null;
  
  // Convert to string for comparison
  const modelId = id.toString();
  
  return window.models.find(model => 
    model.id && model.id.toString() === modelId
  );
}

// Get model ID from URL if present
const modelId = getUrlParameter('id');
const preselectedModel = findModelById(modelId);

// If a model ID was found in the URL and it matches a model, preselect it
if (preselectedModel) {
  // We'll pass this to the Svelte app to initialize with this model
  window.preselectedModel = preselectedModel;
}

const app = new App({
  target: document.getElementById('app'),
})

export default app
